import { Typography } from "@circle-react-uikit/Typography";
import { useVirtualConversation } from "../../hooks/useVirtualConversation";
import { Button } from "./Button";

interface NeedHelpWidgetProps {
  buttonText: string;
  helpText: string;
}

export const NeedHelpWidget = ({
  helpText,
  buttonText,
}: NeedHelpWidgetProps) => {
  const { startVirtualConversation } = useVirtualConversation();

  const handleClick = () => {
    startVirtualConversation("chat");
  };

  return (
    <div className="flex flex-col justify-center">
      <div
        className="border-primary mx-auto mt-auto w-full rounded-lg border p-5"
        style={{
          boxShadow:
            "0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10)",
        }}
      >
        <div className="bg-primary">
          <div className="text-center">
            <Typography.LabelMd weight="semibold" color="dark:text-[#ABAFB2]">
              {helpText}
            </Typography.LabelMd>
          </div>
          <div className="mt-3 flex justify-center">
            <Button
              label={buttonText}
              className="dark:text-primary w-fit rounded-3xl bg-[#2B2E33]"
              onClick={handleClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
